"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStore = void 0;
const services_1 = require("../services");
const form_edit_state_1 = require("../state/form.edit.state");
class FormStore {
    constructor() {
        this.edits = {};
    }
    edit(form) {
        let currentEdit = this.edits[form.version];
        if (currentEdit == null) {
            currentEdit = this.edits[form.version] = new form_edit_state_1.FormEditState(form);
        }
        return currentEdit;
    }
    clearEdit(form) {
        delete this.edits[form.version];
    }
    get(version) {
        const rest = services_1.Services.Department.rest;
        return rest.form('version', version).value;
    }
    fetch(version) {
        const rest = services_1.Services.Department.rest;
        return rest.form('version', version).fetch();
    }
    /**
     * @deprecated Used by legacy mapsight code
     */
    fetchJSON(version) {
        const rest = services_1.Services.Department.rest;
        return rest.Form.getByRevision(version).fetch();
    }
    /**
   * @deprecated Used by legacy mapsight code
   */
    saveJSON(form) {
        const rest = services_1.Services.Department.rest;
        return rest.save(rest.Objects.Form, form);
    }
    exists(version) {
        const rest = services_1.Services.Department.rest;
        const fetchable = rest.form('version', version);
        return fetchable.isFetching || fetchable.value != null;
    }
}
exports.FormStore = FormStore;
//# sourceMappingURL=form.store.js.map